//styles/exportfileStyles.js
export const exportFileStyles = (theme) => ({
  primaryColor: theme.palette.primary.main,
  contrastText: theme.palette.primary.contrastText,
  headerColor: theme.palette.secondary.main,
  headerTextColor: theme.palette.secondary.contrastText,
  rowStripeColor: theme.palette.background.subtle,
  font: theme.typography.fontFamily,
  fontSize: 16,
  marginTop: 20,
  footerY: theme.spacing(2), // Footer positioning
});
